module.exports = __webpack_public_path__ + "img/logo-dark.6fb8b5e3.png";